module.exports = __webpack_public_path__ + "static/media/cardinal_empty.7b3ca03a.svg";